import { inject, Injectable } from '@angular/core';
import { CommonApiService } from '@core/api/common.api.service';
import { catchError, throwError } from 'rxjs';
import { DashboardConfig } from '@root/app/services/dashboard-config/dashboard-charts-config.schema';

@Injectable({
  providedIn: 'root',
})
export class DashboardApiService {
  private _customApi = inject(CommonApiService);

  getDashboardTemplate() {
    const timestamp = new Date().getTime(); // Generate a unique timestampreturn to resolve cache issues;
    return this._customApi
      .get<DashboardConfig>(
        `assets/app-data/configuration.json?timestamp=${timestamp}`
      )
      .pipe(
        catchError(() => {
          return throwError(
            () =>
              new Error(
                'Error while loading dashboard configuration. Please contact support or validate that the configuration file is correct.'
              )
          );
        })
      );
  }
}
